import { Route, Switch } from '@treams/treams-routes';

import Note from './Note';
import ViewerNotes from './ViewerNotes';
import PeerSharedNotes from './PeerSharedNotes';
import NewNote from './NotesNewNote';

type RouteParams = {
	id: string;
	userID: string;
};

export default function Notes() {
	return (
		<Switch>
			<Route path={['/notes/new', '/notes/new/:collaboratorID']} exact>
				<NewNote />
			</Route>
			<Route exact path="/notes/archive">
				<ViewerNotes isArchived={true} />
			</Route>
			<Route exact path="/notes">
				<ViewerNotes />
			</Route>
			<Route<RouteParams> exact path="/users/:id/notes">
				{({ match }) => <PeerSharedNotes userID={match!.params.id!} />}
			</Route>

			<Route<RouteParams> path={['/notes/:id', '/users/:userID/notes/:id']}>
				{({ match }) => <Note id={match!.params.id!} userID={match!.params.userID} />}
			</Route>
		</Switch>
	);
}
